import { useEffect, useState } from "react"
import { FieldType, FieldValue, FilterField, Filters, O } from "../../../../../features/ui"
import { DataType } from '../../../../../tables'
import { useSalesHooks } from "../../../hooks/salesHooks"
import { CustomerType } from "../../../state/types"

type Props = {
    customerTypes: CustomerType[]
    onSearchStart: () => void
    onSearchDone: (dataTypes: DataType[]) => void
}

const FiltersKey = 'customerType'

export const CustomerTypeFilters = (props: Props) => {
    const { customerTypes, onSearchStart, onSearchDone } = props

    const [listLength, setListLength] = useState<number>(-1)
    const [searchText, setSearchText] = useState<string>()

    const { searchCustomerTypes } = useSalesHooks()

    useEffect(() => {
        if (customerTypes.length !== listLength) {
            search(searchText)
        }
        setListLength(customerTypes.length)
    }, [customerTypes])

    const search = (searchTextParam?: string) => {
        onSearchStart()
        const customerTypeList = searchCustomerTypes(customerTypes, searchTextParam)
        setTimeout(() => onSearchDone(customerTypeList), 100)
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText)
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por nombre',
        icon: 'search',
        space: 6,
        onChange: handleSearch
    }

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
        />
    )
}
